import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.ts';
import clsx from 'clsx';
import { BackButton } from '@/components/page-header/back-button.tsx';
import { DrawerAvatarTrigger } from '@/components/page-header/drawer-avatar-trigger.tsx';
import { header, headerContent, headerWithBg } from './page-header.css';

type PageHeaderProps = {
  /** Navigate to this location on Back button click in case of empty history stack */
  fallbackReturnTo?: string;
  noBackground?: boolean;
  noBackButton?: boolean;
  noDrawerAvatarTrigger?: boolean;
};

export const PageHeader: React.FC<React.PropsWithChildren<PageHeaderProps>> = ({
  children,
  fallbackReturnTo,
  noBackground = false,
  noBackButton = false,
  noDrawerAvatarTrigger = false,
}) => {
  const isTablet = useIsTablet();

  return (
    <div className={clsx(header, !noBackground && headerWithBg)}>
      <div className={headerContent}>
        {noBackButton ? null : (
          <BackButton fallbackReturnTo={fallbackReturnTo} />
        )}
        {children}
      </div>
      {!isTablet && !noDrawerAvatarTrigger ? <DrawerAvatarTrigger /> : null}
    </div>
  );
};
